import { useAtomValue } from "jotai";
import { type PropsWithChildren, useEffect } from "react";

import { WelcomeLoadingSpinner } from "@/components/Welcome/WelcomeLoadingSpinner.tsx";
import { clearLocalStorageOnce } from "@/hooks/useClearLocalStorageOnFirstTab";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { isAgentAtom } from "@/utils/atoms";
import { env } from "@/utils/environmentHelpers";

export const LoginRedirect = ({ children }: PropsWithChildren) => {
  const isRedirecting = useLoginRedirect();
  const isAgent = useAtomValue(isAgentAtom);

  useEffect(() => {
    // clearLocalStorageOnce sets SESSION_MARKER (sessionStorage) here at the
    // welcome screen — before the user logs in and navigates to the portal.
    // When App mounts later and calls clearLocalStorageOnce itself, it finds
    // SESSION_MARKER already present and skips the destructive clear, only
    // restarting the heartbeat. Without this pre-login call, App would see no
    // marker and wipe localStorage (including the freshly written auth tokens)
    // on every post-login navigation.
    if (isAgent || env.isDev) {
      return;
    }

    return clearLocalStorageOnce();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isRedirecting) {
    return <WelcomeLoadingSpinner />;
  }

  return children;
};
